import * as React from "react";
const ObjectPositionTopSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 12v1H3v-1h11ZM6 7.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1-5 0Zm1 0C7 8.33 7.67 9 8.5 9S10 8.33 10 7.5 9.33 6 8.5 6 7 6.67 7 7.5Z" }));
ObjectPositionTopSmall.displayName = "ObjectPositionTopSmall";
var ObjectPositionTopSmall_default = ObjectPositionTopSmall;
export {
  ObjectPositionTopSmall_default as default
};
